export const ANIMATE_IMAGE_PROMPT_MAX_LENGTH = 500;

/** Agencies that see the optional prompt modal before image animation. */
export const AGENCIES_WITH_IMAGE_ANIMATION_PROMPT_MODAL = [
  "-O4IsuJUTOyUZujHJwNV",
  "-OSQC3W6cUh2OqqQeMDQ",
];

export const isAgencyWithImageAnimationPromptModal = (agencyID) =>
  Boolean(agencyID) &&
  AGENCIES_WITH_IMAGE_ANIMATION_PROMPT_MODAL.includes(agencyID);
